import Vue from "vue";
import { WhitelabelField, WhitelabelTextFieldMixin, } from "@/components/whitelabel/whitelabel";
import Info from "@/components/Info.vue";
export default Vue.extend({
    name: "WhitelabelImage",
    mixins: [WhitelabelField, WhitelabelTextFieldMixin],
    components: { Info },
    methods: {},
});
